import { PageFooter } from "./components/PageFooter/PageFooter";
import { PageHeader } from "./components/PageHeader/PageHeader";
import { PageContent } from "./components/PageContent/PageContent";
import React, { ReactNode } from "react";
import "./PageContainer.css"

interface Props {
    fixedHeaderFooter?: boolean
    children: ReactNode
}
export const PageContainer = ({ children, fixedHeaderFooter = false }: Props) => {
  return (
    <div className={`page-container ${fixedHeaderFooter ? 'fixedHeaderFooter' : ''}`}>
      <PageHeader />
        <div id="pageContentContainer">
            <PageContent>{children}</PageContent>
        </div>
      <PageFooter />
    </div>
  );
};
